export const capitalizeLetter = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };